<script setup lang="ts">
// Styled native <select> with a chevron (replaces the legacy ds-dash .select/.sel-chev).
// v-model passthrough via defineModel; the default slot holds <option>/<optgroup>.
// inheritAttrs: false so id/aria land on the <select> instead of the wrapper div.
defineOptions({ inheritAttrs: false });

const model = defineModel<string>();
</script>

<template>
  <div class="relative flex items-center">
    <select
      v-model="model"
      v-bind="$attrs"
      class="w-full cursor-pointer appearance-none rounded-md border border-input bg-card px-3.5 py-2 pe-8 text-sm font-medium outline-none transition-[border-color,box-shadow] focus:border-primary focus:ring-2 focus:ring-primary/30 [@media(pointer:coarse)]:min-h-11"
    >
      <slot />
    </select>
    <span class="pointer-events-none absolute end-3 text-subtle-foreground" aria-hidden="true">
      <Icon name="lucide:chevron-down" class="block h-4 w-4" />
    </span>
  </div>
</template>
